export const SET_LOCALE = "SET_LOCALE";
export const SET_CURRENCY = "SET_CURRENCY";

export default {
  SET_LOCALE,
  SET_CURRENCY,
};
